/*
  Ballr — mobile bottom bar.

  Handles the buttons whose action is not a plain link, and mirrors the header's cart
  count so the badge stays right after an add to cart.
*/
(function () {
  var bar = document.querySelector('[data-ballr-mobilebar]');
  if (!bar) return;

  bar.addEventListener('click', function (event) {
    var item = event.target.closest('.ballr-mobilebar__item');
    if (!item || !bar.contains(item)) return;
    var action = item.dataset.action;

    if (action === 'cart') {
      var drawer = document.querySelector('cart-drawer');
      var onCartPage = window.location.pathname.indexOf('/cart') === 0;
      // No drawer, or we are already on the cart page: let the link through.
      // Do NOT test the drawer's `is-empty` class — it reflects the cart at page load,
      // not now, so it goes stale as soon as something is added.
      if (!drawer || onCartPage || typeof drawer.open !== 'function') return;
      event.preventDefault();
      drawer.open();
      return;
    }

    if (action === 'menu') {
      event.preventDefault();
      var details = document.querySelector('header-drawer details, .header__icon--menu');
      if (!details) return;
      var summary = details.querySelector ? details.querySelector('summary') : null;
      if (summary) summary.click();
      else details.click();
      return;
    }

    if (action === 'search') {
      var searchToggle = document.querySelector('details-modal .header__icon--search, .header__icon--search');
      if (searchToggle && searchToggle.tagName === 'SUMMARY') {
        event.preventDefault();
        searchToggle.click();
      }
      // Otherwise the link to /search handles it.
    }
  });

  // Keep the badge in step with the header bubble, which Dawn re-renders on every cart change.
  var badge = bar.querySelector('[data-ballr-mobilebar-count]');
  var bubbleHost = document.getElementById('cart-icon-bubble');
  if (!badge || !bubbleHost) return;

  function readCount() {
    var el = bubbleHost.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    if (el) return parseInt(el.textContent.trim(), 10) || 0;
    return bubbleHost.querySelector('.cart-count-bubble') ? 1 : 0;
  }

  function sync() {
    var count = readCount();
    badge.textContent = count;
    badge.classList.toggle('is-empty', count === 0);
  }

  new MutationObserver(function () {
    sync();
  }).observe(bubbleHost, { childList: true, subtree: true, characterData: true });

  sync();
})();
